<template>
  <div class="timeline-container">
    <div class="timeline">
      <div class="line" v-if="timelineData && timelineData.length > 0">
        <div v-for="(group, gIndex) in safeType" :key="gIndex" class="group-row safe-state">
          <div class="line-title">安全状态图</div>
          <div class="events-row">
            <div
              v-for="(item, iIndex) in group.items"
              :key="iIndex"
              class="event-bar"
              :class="`risk-${item.riskLevel}`"
              :style="{ position: 'absolute', marginLeft: timeLeft(item), width: timeWidth(item) }"
              @mouseenter="showTip($event, item)"
              @mouseleave="hideTip">
              <div v-for="(hidden, idx) in item.positions" :key="idx" class="position">
                {{ hidden }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="highRisk.length > 0" class="line-part">
          <div class="line-title">中高危隐患</div>
          <div v-for="(group, gIndex) in highRisk" :key="gIndex" class="group-row">
            <div class="group-label">{{ group.groupName }}</div>
            <div class="events-row">
              <div
                v-for="(item, iIndex) in group.items"
                :key="iIndex"
                class="event-bar"
                :class="`risk-${item.riskLevel}`"
                :style="{ position: 'absolute', marginLeft: timeLeft(item), width: timeWidth(item) }"
                @mouseenter="showTip($event, item)"
                @mouseleave="hideTip">
                <div v-for="(hidden, idx) in item.positions" :key="idx" class="position">
                  {{ hidden }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="misreport.length > 0"  class="line-part">
          <div class="line-title">{{ riskLevel.name(6) }}</div>
          <div v-for="(group, gIndex) in misreport" :key="gIndex" class="group-row">
            <div class="group-label">{{ group.groupName }}</div>
            <div class="events-row">
              <div
                v-for="(item, iIndex) in group.items"
                :key="iIndex"
                class="event-bar"
                :class="`risk-${item.riskLevel}`"
                :style="{ position: 'absolute', marginLeft: timeLeft(item), width: timeWidth(item) }"
                @mouseenter="showTip($event, item)"
                @mouseleave="hideTip">
                <div v-for="(hidden, idx) in item.positions" :key="idx" class="position">
                  {{ hidden }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="otherHidden.length > 0"  class="line-part">
          <div class="line-title">其他隐患</div>
          <div v-for="(group, gIndex) in otherHidden" :key="gIndex" class="group-row">
            <div class="group-label">{{ group.groupName }}</div>
            <div class="events-row">
              <div
                v-for="(item, iIndex) in group.items"
                :key="iIndex"
                class="event-bar"
                :class="`risk-${item.riskLevel}`"
                :style="{ position: 'absolute', marginLeft: timeLeft(item), width: timeWidth(item) }"
                @mouseenter="showTip($event, item)"
                @mouseleave="hideTip">
                <div v-for="(hidden, idx) in item.positions" :key="idx" class="position">
                  {{ hidden }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部时间刻度 -->
        <div class="scale-row">
          <div class="scale-label"></div>
          <div class="scale-line">
        <span
          v-for="h in scaleTicks"
          :key="h"
          class="scale-tick"
          :style="{ left: ((h / 24) * 100) + '%' }">
          {{ h.toString().padStart(2, '0') }}:00
        </span>
          </div>
        </div>
      </div>
      <div class="line" v-else-if="outsideMonitorPeriod">
        <div class="outside-hint">
          <span class="outside-icon"><i class="el-icon-time"></i></span>
          <span class="outside-text">不在监测时间范围内</span>
        </div>
      </div>
      <div class="line" v-else>
        <!-- 无数据且在监测时段内，无额外提示 -->
      </div>

      <!-- 跟随鼠标 tooltip -->
      <div
        v-if="tipVisible"
        class="tooltip"
        :style="{ top: tipY + 'px', left: tipX + 'px' }">
        <div style="display: flex; gap: 10px">
          <div>{{ tipContent.riskName }}</div>
          <div v-for="(item, index) in hiddenPosition" :key="index">
            {{ item }}
          </div>
        </div>
        <div>
          {{ tipContent.startDateTime }} - {{ tipContent.endDateTime }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { processTimelineData } from "@/scripts/timelineProcessor";
import riskLevel from "@/scripts/riskLevel";

export default {
  name: "TimeLine",
  props: {
    timelineData: {
      type: Array,
      default: () => []
    },
    outsideMonitorPeriod: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      safeType: [],
      highRisk: [],
      misreport: [],
      otherHidden: [],
      tipVisible: false,
      tipX: 0,
      tipY: 0,
      tipContent: {},
      hiddenPosition:[]
    };
  },
  computed: {
    riskLevel() {
      return riskLevel
    },
    scaleTicks() {
      return [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
    }
  },
  watch: {
    timelineData: {
      handler(newVal) {
        const result = processTimelineData(newVal || []);
        this.safeType = result.safeType;
        this.highRisk = result.highRisk;
        this.misreport = result.misreport;
        this.otherHidden = result.otherHidden;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    timeLeft(item) {
      const hiddenStart = new Date(item.startDateTime).setHours(0, 0, 0, 0);
      const start = new Date(item.startDateTime);
      const total = 24 * 60 * 60 * 1000;
      return ((start - hiddenStart) / total) * 100 + '%';
    },
    timeWidth(item) {
      const start = new Date(item.startDateTime);
      const end = new Date(item.endDateTime);
      const total = 24 * 60 * 60 * 1000;
      return ((end - start) / total) * 100 + '%';
    },
    showTip(e, item) {
      this.tipContent = item;
      this.tipVisible = true;
      this.hiddenPosition = this.tipContent.positions || [];
      const move = (ev) => {
        this.tipX = ev.clientX + 12;
        this.tipY = ev.clientY + 12;
      };
      document.addEventListener('mousemove', move);
      e.target._moveHandler = move;
    },
    hideTip(e) {
      this.tipVisible = false;
      if (e.target._moveHandler) {
        document.removeEventListener('mousemove', e.target._moveHandler);
      }
    }
  },
  mounted() {

  }
};
</script>

<style scoped>
.timeline-container {
  flex: 1;
  display: flex;
}

.timeline {
  flex: 1;
  min-width: 0;
  position: relative;
  box-sizing: border-box;
  padding: 10px 20px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
}

.line {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-right: 20px;
  box-sizing: border-box;
}

.line-part {
  padding: 2px 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  margin-top: 5px;
}

.nodata {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  color: rgba(0, 139, 7, 0.5);
  font-size: 30px !important;
}

.line-title {
  font-size: 16px;
  line-height: 26px;
  font-weight: bolder;
  width: 100px;
  text-align: left;
  font-family: OPPOSans-M, sans-serif;
}

.group-row {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.safe-state {
  margin-bottom: 5px;
}

.group-label {
  font-size: 14px;
  width: 100px;
  color: #666;
  flex-shrink: 0;
  text-align: right;
  padding-right: 10px;
  font-family: OPPOSans-M, sans-serif;
}

.events-row {
  position: relative;
  flex: 1;
  display: flex;
  height: 15px;
  box-sizing: border-box;
}

.event-bar {
  height: 100%;
  transition: all 0.2s;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 20px;
  position: relative;
}

/* 风险等级颜色 */
.event-bar.risk-1 {
  background: #00DAAE;
}

.event-bar.risk-2 {
  background: #378def;
}

.event-bar.risk-3 {
  background: #378def;
}

.event-bar.risk-4 {
  background: #ff7a45;
}

.event-bar.risk-5 {
  background: #ed0e20;
}

.event-bar.risk-6 {
  background: #6c6c6c;
}

.position{
  font-size: 12px;
  position: absolute;
  width: 100px;
  text-align: center;
  left: 50%;
  transform: translate(-50%,-100%);
}

.scale-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.scale-label {
  width: 100px;
  flex-shrink: 0;
}

.scale-line {
  flex: 1;
  position: relative;
  height: 15px;
  border-top: 1px solid #aaa;
}

.scale-tick {
  position: absolute;
  transform: translateX(-50%);
  font-size: 11px;
  color: #666;
  top: 4px;
}

.tooltip {
  position: fixed;
  padding: 6px 10px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none;
  z-index: 9999;
  white-space: nowrap;
}

.outside-hint {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px dashed #d0d5dd;
  border-radius: 8px;
  padding: 32px 24px;
  margin: 16px 0;
  min-height: 80px;
  box-sizing: border-box;
}

.outside-icon {
  font-size: 22px;
  color: #98a2b3;
  line-height: 1;
}

.outside-text {
  font-size: 15px;
  color: #98a2b3;
  font-weight: 450;
  line-height: 1.5;
  letter-spacing: 0.02em;
}
</style>
